
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
    tab: {
      default: 'BookOverview',
    },
  },
}
